import script from "./NetworkSection.vue?vue&type=script&setup=true&lang=js"
export * from "./NetworkSection.vue?vue&type=script&setup=true&lang=js"

import "./NetworkSection.vue?vue&type=style&index=0&id=6148e00a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6148e00a"]])

export default __exports__